import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Item from "../Components/Item/Item";
import { backend_url } from "../App";
import Spinner from "../Components/Spinner/Spinner";
import { useSearchParams } from "react-router-dom";

const ShopCategory = (props) => {
  const { subcategory } = useParams();
  const [allproducts, setAllProducts] = useState([]);
  const [sortOption, setSortOption] = useState("Bestselling");
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = parseInt(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(pageFromQuery);
  const productsPerPage = 16;

  useEffect(() => {
    const fetchInfo = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${backend_url}/allproducts`);
        const data = await res.json();
        setAllProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
      setLoading(false);
    };

    fetchInfo();
  }, []);

  useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, [currentPage]);

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;
    setCurrentPage(page);
  }, [searchParams]);

  const filteredProducts = allproducts.filter(
    (item) =>
      item.subcategory?.toLowerCase().trim() ===
      subcategory?.toLowerCase().trim()
  );

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortOption) {
      case "A-Z":
        return a.name.localeCompare(b.name);
      case "Z-A":
        return b.name.localeCompare(a.name);
      case "Price high to low":
        return b.new_price - a.new_price;
      case "Price low to high":
        return a.new_price - b.new_price;
      case "Date new to old":
        return new Date(b.date) - new Date(a.date);
      case "Date old to new":
        return new Date(a.date) - new Date(b.date);
      default:
        return 0;
    }
  });

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = sortedProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const totalPages = Math.ceil(sortedProducts.length / productsPerPage);

  // Format the subcategory (replace hyphens and capitalize first letter)
  const formattedHeader = subcategory
    ? subcategory
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : "Category";

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="w-full max-w-screen-xl mx-auto px-4">
          <p className="text-[12px]">Home / {formattedHeader}</p>
          {/* Header and Sort Section */}
          <div className="flex flex-col sm:flex-col  md:flex-row xl:flex-row lg:flex-row items-start xs:items-center justify-between gap-3 mb-6">
            {/* Header Section */}
            <div>
              <h2
                className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-4"
                style={{ fontFamily: "'Times New Roman', Serif" }}
              >
                {formattedHeader}
              </h2>
            </div>
            {/* Sort by Dropdown */}
            <div className="flex items-center w-[300px] xs:w-auto mt-2 xs:mt-0 xs:flex-1">
              <label
                htmlFor="sort"
                className="mr-2 text-[16px] xs:text-sm whitespace-nowrap"
              >
                Sort by:
              </label>
              <select
                id="sort"
                className="border p-1 xs:p-2 rounded-md text-[16px] xs:text-sm w-full xs:w-auto"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
              >
                <option>Bestselling</option>
                <option>A-Z</option>
                <option>Z-A</option>
                <option>Price high to low</option>
                <option>Price low to high</option>
                <option>Date new to old</option>
                <option>Date old to new</option>
              </select>
            </div>
          </div>

          {/* Product Grid - 2 columns on mobile */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mb-10">
            {currentProducts.map((item) => {
              const offerPrice =
                (item.old_price * (100 - item.new_price)) / 100;
              const discountPercentage =
                ((item.old_price - offerPrice) / item.old_price) * 100;

              return (
                <div key={item.id} className="aspect-square">
                  {" "}
                  {/* Square container */}
                  <Item
                    id={item.id}
                    name={item.name}
                    image={item.images?.[0] || ""}
                    new_price={offerPrice.toFixed(2)}
                    old_price={item.old_price}
                    discountPercentage={discountPercentage.toFixed(0)}
                  />
                </div>
              );
            })}
          </div>

          {/* Pagination - Mobile friendly */}
          {totalPages > 1 && (
            <div className="flex flex-wrap justify-center gap-2 mb-6">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`px-3 py-1 sm:px-4 sm:py-2 rounded-md text-xs sm:text-sm ${
                    currentPage === i + 1
                      ? "bg-purple-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-purple-500 hover:text-white"
                  }`}
                  onClick={() => {
                    setCurrentPage(i + 1);
                    setSearchParams({ page: i + 1 });
                  }}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ShopCategory;
